import axios from '../utils/axios';

const MeService = {

    // ── Frameworks ────────────────────────────────────────────────
    getFrameworks:       (filters = {})    => axios.get('me/frameworks',           { params: filters }),
    getFrameworkDetail:  (id)              => axios.get(`me/frameworks/${id}`),
    saveFramework:       (data)            => axios.post('me/frameworks/save', data),
    deleteFramework:     (id)              => axios.post(`me/frameworks/${id}/delete`),

    // ── Sections ──────────────────────────────────────────────────
    getSections:         (framework_id)    => axios.get('me/sections',             { params: { framework_id } }),
    saveSection:         (data)            => axios.post('me/sections/save', data),
    bulkSaveSections:    (sections)        => axios.post('me/sections/bulk-save',  { sections }),
    deleteSection:       (id)              => axios.post(`me/sections/${id}/delete`),

    // ── Indicators ────────────────────────────────────────────────
    getIndicators:       (filters = {})    => axios.get('me/indicators',           { params: filters }),
    saveIndicator:       (data)            => axios.post('me/indicators/save', data),
    bulkSaveIndicators:  (indicators)      => axios.post('me/indicators/bulk-save',{ indicators }),
    deleteIndicator:     (id)              => axios.post(`me/indicators/${id}/delete`),

    // ── Assignments ───────────────────────────────────────────────
    getAssignments:      (filters = {})    => axios.get('me/assignments',          { params: filters }),
    getAssignmentDetail: (id)              => axios.get(`me/assignments/${id}`),
    saveAssignment:      (data)            => axios.post('me/assignments/save', data),
    bulkAssign:          (data)            => axios.post('me/assignments/bulk-assign', data),
    deleteAssignment:    (id)              => axios.post(`me/assignments/${id}/delete`),

    // ── Progress ──────────────────────────────────────────────────
    getProgress:         (filters = {})    => axios.get('me/progress',             { params: filters }),
    getProgressSummary:  (filters = {})    => axios.get('me/progress/summary',     { params: filters }),
    saveProgress:        (data)            => axios.post('me/progress/save', data),
    bulkSaveProgress:    (data)            => axios.post('me/progress/bulk-save', data),
    verifyProgress:      (id, data)        => axios.post(`me/progress/${id}/verify`, data),
    bulkVerify:          (data)            => axios.post('me/progress/bulk-verify', data),

    // ── Periods ───────────────────────────────────────────────────
    getMePeriods:        (framework_id)    => axios.get('me/periods',              { params: { framework_id } }),
    saveMePeriod:        (data)            => axios.post('me/periods/save', data),

    // ── Analytics ─────────────────────────────────────────────────
    getDashboard:        (filters = {})    => axios.get('me/dashboard',            { params: filters }),
    getHeatmap:          (filters = {})    => axios.get('me/heatmap',              { params: filters }),
    getTrend:            (filters = {})    => axios.get('me/trend',                { params: filters }),
    getOverdueActions:   (filters = {})    => axios.get('me/overdue-actions',      { params: filters }),

    // ── Comments ──────────────────────────────────────────────────
    getComments:         (progress_id)     => axios.get('me/comments',             { params: { progress_id } }),
    addComment:          (data)            => axios.post('me/comments/add', data),

    // ── Auto-sync ─────────────────────────────────────────────────
    syncAutoIndicators:  (data)            => axios.post('me/sync/qoc-assessments', data),
};

export default MeService;